import SubmenuItem from './SubmenuItem';
import { SubmenuItemProps, SubmenuItemValueProps } from './types';

export type { SubmenuItemProps, SubmenuItemValueProps };
export default SubmenuItem;
